import { useState, useCallback } from 'react';
import { useMountedState } from 'react-use';

export const useControlledModalSheet = ({ onClosing, onClose }) => {
    const [closing, setClosing] = useState(false);
    const [probing, setProbing] = useState(false);
    const isMounted = useMountedState();

    const handleClose = useCallback(
        async (...args) => {
            if (probing || !isMounted()) {
                return;
            }

            if (onClosing) {
                setProbing(true);

                try {
                    if (false === (await onClosing(...args))) {
                        return;
                    }
                } finally {
                    isMounted() && setProbing(false);
                }
            }

            setClosing(args);
        },
        [probing, onClosing]
    );

    const handleClosed = useCallback(() => {
        if (isMounted()) {
            setClosing(false);
        }

        onClose && onClose(...(closing || []));
    }, [closing, onClose]);

    return {
        isClosing: !!closing && !probing,
        onClose: handleClose,
        onExit: handleClosed,
    };
};
